import {
  GENDER_TYPES,
  MARITAL_STATUS,
  USER_TYPE_SLUGS,
} from "../../utils/enums";
import { AgentList, CompanyList, UsersList } from "../../types/General";
import moment from "moment";

type props = {
  type: any;
  details: UsersList | CompanyList | AgentList | null;
};
const PersonalInformation = ({ type, details }: props) => {
  return (
    <>
      <div className="profileInfo_head">
        <h2>
          {type === USER_TYPE_SLUGS.COMPANY
            ? "Representative Details"
            : "Personal Details"}
        </h2>
      </div>

      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          <li className="w_50">
            <strong>{"Name"}</strong>
            <span>
              {details?.first_name || "-"} {details?.middle_name}{" "}
              {details?.last_name}
            </span>
          </li>

          <li className="w_50">
            <strong>{"E-mail"}</strong>
            <span>{details?.email || "-"}</span>
          </li>
          {type === USER_TYPE_SLUGS.SALARIED_AGENT ? (
            <>
              {/* <li className="w_50">
                <strong>Personal phone number</strong>
                <span>+91 899788655</span>
              </li>
              <li className="w_50">
                <strong>Company phone number</strong>
                <span>+91 899788655</span>
              </li>
              <li className="w_50">
                <strong>Emergency phone number</strong>
                <span>+91 899788655</span>
              </li> */}
            </>
          ) : (
            <li className="w_50">
              <strong>{"Phone"}</strong>
              <span>
                {details?.country_code} {details?.phone_no || "-"}
              </span>
            </li>
          )}
          {type === USER_TYPE_SLUGS.COMPANY ? (
            <li className="w_50">
              <strong>Desination</strong>
              <span>{details?.designation || "-"} </span>
            </li>
          ) : null}
          {type === USER_TYPE_SLUGS.INDIVIDUAL ? (
            <>
              <li className="w_50">
                <strong>Residence Mobile No.</strong>
                <span>
                  {details?.residence_country_code}{" "}
                  {details?.residence_phone_no || "-"}
                </span>
              </li>
              <li className="w_50">
                <strong>Residence Id</strong>
                <span>{details?.residence_id || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Country of Birth</strong>
                <span>{details?.country_of_birth || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Religion</strong>
                <span>{details?.religion || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Citizenship</strong>
                <span>{details?.citizenship || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Country of residence</strong>
                <span>{details?.country_of_residence || "-"}</span>
              </li>
            </>
          ) : null}

          {type === USER_TYPE_SLUGS.COMPANY ? (
            <>
              <li className="w_50">
                <strong>Trade License Number</strong>
                <span>{details?.trade_license_number || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Business Registration Number</strong>
                <span>{details?.business_registration_number || "-"}</span>
              </li>
            </>
          ) : null}

          {type === USER_TYPE_SLUGS.SALARIED_AGENT ||
          type === USER_TYPE_SLUGS.COMPANY ? null : (
            <>
              <li className="w_50">
                <strong>Gender</strong>
                <span>
                  {details?.gender ? GENDER_TYPES[details?.gender] : "-"}
                </span>
              </li>
              <li className="w_50">
                <strong>DOB</strong>
                <span>{details?.birthdate || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Civil Status</strong>
                <span>
                  {details?.martial_status
                    ? MARITAL_STATUS[details?.martial_status]
                    : "-"}
                </span>
              </li>

              {type === USER_TYPE_SLUGS.FREELANCER_AGENT ? (
                <li className="w_50">
                  <strong>Services Offered</strong>
                  <span>{details?.service_offered || "-"}</span>
                </li>
              ) : (
                <>
                  <li className="w_50">
                    <strong>Passport Number</strong>
                    <span>{details?.passport || "-"} </span>
                  </li>
                  <li className="w_50">
                    <strong>Passport Issue date</strong>
                    <span>{details?.passport_issued_date || "-"} </span>
                  </li>
                  <li className="w_50">
                    <strong>Passport Expiry Date</strong>
                    <span>{details?.passport_expiry_date || "-"} </span>
                  </li>
                  <li className="w_50">
                    <strong>Visa Expiry Date</strong>
                    <span>{details?.visa_expiry_date || "-"} </span>
                  </li>
                </>
              )}
            </>
          )}

          <li className="w_50">
            <strong>Address</strong>
            <span>{details?.address || "-"}</span>
          </li>
          <li className="w_50">
            <strong>State</strong>
            <span>{details?.state || "-"}</span>
          </li>
          <li className="w_50">
            <strong>City</strong>
            <span>{details?.city || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Postal Code</strong>
            <span>{details?.pin_code || "-"}</span>
          </li>
          {type === USER_TYPE_SLUGS.INDIVIDUAL ? (
            <>
              {" "}
              <li className="w_50">
                <strong> Current Job Profession</strong>
                <span>{details?.current_job || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Workplace Address</strong>
                <span>{details?.work_address || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Work State</strong>
                <span>{details?.work_state || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Work City</strong>
                <span>{details?.work_city || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Work Postal Code</strong>
                <span>{details?.work_pin_code || "-"}</span>
              </li>
              <li className="w_50">
                <strong>B2B Name</strong>
                <span>{details?.work_company_name || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Employer Phone Number</strong>
                <span>{`${details?.work_company_country_code} ${details?.work_company_phone_no || "-"}`}</span>
              </li>
              <li className="w_50">
                <strong>Employer Email</strong>
                <span>{details?.work_company_email || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Applied Position</strong>
                <span>{details?.applied_position || "-"}</span>
              </li>
            </>
          ) : null}
          <li className="w_50">
            <strong> Registration Date</strong>
            <span>
              {details?.created_at
                ? moment(details?.created_at).format("DD MMM YYYY")
                : "-"}
            </span>
          </li>

          {type === USER_TYPE_SLUGS.INDIVIDUAL ? null : (
            <>
              <li className="w_50">
                <strong>Active applicants</strong>
                <span>{details?.active_applicant || 0}</span>
              </li>
              <li className="w_50">
                <strong>In-active applicants</strong>
                <span>{details?.in_active_applicant || 0}</span>
              </li>
              <li className="w_50">
                <strong>In-progress applications</strong>
                <span>{details?.in_progress_applicants || 0}</span>
              </li>
              <li className="w_50">
                <strong>Completed applications</strong>
                <span>{details?.completed_applicant || 0}</span>
              </li>
              <li className="w_50">
                <strong>Total revenue</strong>
                <span>AED {details?.total_revenue || 0}</span>
              </li>
            </>
          )}
        </ul>
      </div>

      {type === USER_TYPE_SLUGS.COMPANY ? (
        <>
          {" "}
          <h2 style={{ margin: "30px 0 20px" }}>B2B Details</h2>
          <div className="profileInfo_list">
            <ul className="text_info gap_p">
              <li className="w_50">
                <strong>Name</strong>
                <span>{details?.company_name || ""}</span>
              </li>

              <li className="w_50">
                <strong>Email</strong>
                <span>{details?.company_email || "-"}</span>
              </li>

              <li className="w_50">
                <strong>Phone</strong>
                <span>
                  {details?.company_country_code || ""}{" "}
                  {details?.company_phone_no || "-"}
                </span>
              </li>
            </ul>
          </div>
        </>
      ) : null}

      {(type === USER_TYPE_SLUGS.COMPANY && details?.reject_reason) ||
      (type === USER_TYPE_SLUGS.FREELANCER_AGENT && details?.reject_reason) ? (
        <>
          {" "}
          <div className="profileInfo_list" style={{ marginTop: "20px" }}>
            <ul className="text_info gap_p">
              <li className="w_50">
                <strong>Rejected Reason</strong>
                <span>{details?.reject_reason || ""}</span>
              </li>
            </ul>
          </div>
        </>
      ) : null}
    </>
  );
};

export default PersonalInformation;
